import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import useTranslation from '../../../utils/translation'
import settings from '../settings'
import { BRAND_MAGNET } from '../constants'

const MagnetContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${theme('colors.headerBackground')};
  color: ${theme('colors.backgroundPrimary')};
  height: 130px;

  ${(props) => props.theme.media.min.sm`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 42px 68px 40px 57px;
    height: 70px;
  `}
`

const LeftPart = styled.div`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  width: 100%;
  height: 80px;
  padding-top: 18px;

  ${(props) => props.theme.media.min.sm`
    font-size: 18px;
    line-height: 23px;
    text-align: left;
    height: auto;
    padding-top: 0;
  `}
`

const TextDiv = styled.div`
  display: block;

  ${(props) => props.theme.media.min.sm`
    display: inline;
  `}
`

const RightPart = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  height: 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 14px;

  ${(props) => props.theme.media.min.sm`
    font-size: 18px;
    line-height: 23px;
    text-align: right;
    height: auto;
    border-top: none;
    padding-top: 0;
  `}
`

const DefaultContainer = styled.div`
  height: 70px;
  text-align: center;
  width: 100%;
  background-color: ${theme('colors.primary')};
  color: ${theme('colors.backgroundPrimary')};
  font-weight: 600;
  padding: 25px;
  font-family: ${theme('typography.paragraph.fontFamily')};
`

const LoggedInBanner = () => {
  const t = useTranslation('app.loggedin-banner')

  return settings.brand !== BRAND_MAGNET ? (
    <DefaultContainer>{t('text')}</DefaultContainer>
  ) : (
    <MagnetContainer>
      <LeftPart>
        <TextDiv style={{ fontWeight: 550 }}>
          {t('status')}
        </TextDiv>
        <TextDiv>{t('role')}</TextDiv>
      </LeftPart>
      <RightPart>
        <TextDiv>{t('notice')}</TextDiv>
      </RightPart>
    </MagnetContainer>
  )
}

export default LoggedInBanner
